/**
 * Client Portal v2 -- the canonical 3-band color/legend system (PR D).
 *
 * Build contract:
 * docs/planning/2026-06-30-client-portal-v2-data-api-refactor.md section 8a
 * (the three disjoint + additive funding bands: budget / allowance /
 * external). Every banded chart in the portal (Overview funding-mix bar,
 * Overview spend-over-time series, sales-by-store / -department / -period)
 * stacks these SAME three bands in the SAME colors, with one shared legend
 * (BandLegend.vue) -- so a reader learns the color key once.
 *
 * Colors are pulled from the existing ThreadFlow design tokens
 * (frontend/src/styles/_tokens.css) rather than invented, so the bands match
 * the rest of the portal/distributor chrome:
 *
 *   - budget    -> --tf-primary  (ThreadFlow blue): the company's top-down
 *     budget spend -- the "house money" band, the brand-primary color.
 *   - allowance -> --tf-success  (green): per-shopper allowance credit -- a
 *     "granted credit" reads naturally as green.
 *   - external  -> --tf-warning  (amber): card / ApplePay / other external
 *     payment -- shopper-out-of-pocket money, the attention/amber band.
 *
 * These three are visually distinct (blue / green / amber) and already
 * carry semantic weight elsewhere in the system, so the legend is
 * self-reinforcing.
 */

// Render order = stack order, left-to-right / bottom-to-top: budget,
// allowance, external (matches the section 8a band table order).
export const BAND_DEFS = Object.freeze([
    Object.freeze({
        key: "budget",
        label: "Budget",
        // CSS var with a hard fallback so the bar still colors in a test
        // environment that doesn't load _tokens.css.
        color: "var(--tf-primary, #119ae9)",
        centsKey: "budget_cents",
    }),
    Object.freeze({
        key: "allowance",
        label: "Allowance",
        color: "var(--tf-success, #00d084)",
        centsKey: "allowance_cents",
    }),
    Object.freeze({
        key: "external",
        label: "External",
        color: "var(--tf-warning, #fcb900)",
        centsKey: "external_cents",
    }),
]);
